<template>
    <rkm-modal
        ref="modal"
        title="Mensagens e respostas"
        large
    >
        <rkm-form
            ref="Form"
            show-legend
        >
            <div v-if="model.mensagensResposta && model.mensagensResposta.length">
                <div v-for="(mensagem, index) in model.mensagensResposta" :key="index">

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                label="Mensagem"
                                :readonly="true"
                                v-model="mensagem.mensagem.mensagemConteudo"
                                class="mb-2"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col class="d-flex justify-content-end">
                            <small>
                                <em>Data: {{ mensagem.mensagem.mensagemData }}</em>&nbsp;&nbsp;
                                <em>Hora: {{ mensagem.mensagem.mensagemHora }}</em>&nbsp;&nbsp;
                                <em>Usuário: {{ mensagem.mensagem.mensagemUsuario }}</em>
                            </small>
                        </rkm-col>
                    </rkm-row>
                    <hr class="mt-1 mb-1">

                    <rkm-row>
                        <rkm-col>
                            <rkm-form-textarea
                                v-if="mensagem.resposta"
                                :readonly="mensagem.resposta ? true : false"
                                :value="mensagem.resposta ? mensagem.resposta.respostaMensagem : ''"
                                class="mb-2"
                                label="Resposta"
                            />
                            <rkm-form-textarea
                                v-else
                                :validations="validations.resposta"
                                class="mb-2"
                                label="Resposta"
                                v-model="model.ultimaResposta"
                            />
                        </rkm-col>
                    </rkm-row>

                    <rkm-row>
                        <rkm-col class="d-flex justify-content-end">
                            <small v-if="mensagem.resposta">
                                <em>Data: {{ mensagem.resposta.respostaData }}</em>&nbsp;&nbsp;
                                <em>Hora: {{ mensagem.resposta.respostaHora }}</em>&nbsp;&nbsp;
                                <em>Usuário: {{ mensagem.resposta.respostaUsuario }}</em>
                            </small>
                        </rkm-col>
                    </rkm-row>
                    <hr v-if="mensagem.resposta" class="mt-1 mb-1">
                </div>
            </div>
        </rkm-form>

        <template v-slot:footer="{ cancel }">
            <rkm-button @click="cancel">Cancelar</rkm-button>
            <rkm-button @click="save" color="primary" type="submit">Salvar</rkm-button>
        </template>
    </rkm-modal>
</template>

<script>

// Mixin.
import { repository, stringCase } from '@/mixins'

// Enums.
import statusTipo from '@/enums/manutencao/statusTipo'

export default {
     computed: {
        validations() {
            return {
                resposta: {
                    max: 500,
                    required: true,
                }
            }
        }
    },
    created() {

        this.repositories = {
            solicitacao: this.getConectaSusRepository('manutencao.solicitacao'),
        }
    },
    data: () => ({
        model: {
            id: null,
            mensagensResposta: [],
            ultimaResposta: null,
            ultimaMensagemId: null,
        },
        enums: { statusTipo}
    }),
    methods: {

        open(item) {

            this.model.id = item.id
            this.model.mensagensResposta = item.mensagensResposta || [];
            this.model.ultimaResposta = null

            const ultimaMensagemSemResposta = this.model.mensagensResposta.find(mensagem => !mensagem.resposta);
            this.ultimaMensagemId = ultimaMensagemSemResposta ? ultimaMensagemSemResposta.mensagem.mensagemId : null;

            this.$refs.modal.show()
        },
        save() {

            if (!this.model.ultimaResposta) {
                return;
            }

            this.$refs.Form.validate()
                .then((valid) => {
                    if (valid) {

                        const request = {
                            acao: 'responder',
                            resposta: this.model.ultimaResposta,
                            mensagemId: this.ultimaMensagemId,
                        }

                        this.repositories.solicitacao.update(
                            this.model.id,
                            this.prepareData(request)
                        )
                            .then(() => {
                                this.$refs.modal.hide()
                                this.$emit('refresh')
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                })

        },
        prepareData(request) {

            return this.camelObjectKeysToSnakeRecursive(request);
        }
    },
    mixins: [ repository, stringCase ],
    props: {
        item: {
            type: Object,
            default: () => ({})
        }
    }
}
</script>